import type { UserData, UserResponse, LoginResponse } from '@/types'
import { ref } from 'vue'
import { useApi } from '@/lib/api'
import { setAdapter, favouriteStationIds } from '@/lib/favouriteStations'
import { favouriteStationsAdapterApi } from '@/lib/favouriteStationsAdapterApi'
import { favouriteStationsAdapterLocalStorage } from '@/lib/favouriteStationsAdapterLocalStorage'

export const userIsLoggedIn = ref<boolean>(false)
export const userData = ref<UserData>({})
export const userApi = useApi()

export const initSession = async (): Promise<typeof userData> => {
  try {
    const response = await userApi.ky.get('user/').json<UserResponse>()

    userData.value = response.data
    userIsLoggedIn.value = response.is_logged_in
  } catch (_e) {
    userData.value = {}
    userIsLoggedIn.value = false
  }

  if (userIsLoggedIn.value === true) {
    setAdapter(favouriteStationsAdapterApi)
  } else {
    setAdapter(favouriteStationsAdapterLocalStorage)
  }

  return userData
}

export const destroySession = () => {
  userIsLoggedIn.value = false
  userData.value = {}
  setAdapter(favouriteStationsAdapterLocalStorage)
}

export const login = async (): Promise<void> => {
  try {
    const response = await userApi.ky
      .post(`user/login`, {
        json: {
          favourites: favouriteStationIds.value,
        },
      })
      .json<LoginResponse>()

    if (!response?.data?.login_url) {
      return
    }

    window.location.href = response.data.login_url
  } catch (e) {
    console.error(e)
  }
}

export const logout = async (): Promise<void> => {
  try {
    await userApi.ky.get('user/logout').json<UserResponse>()
    destroySession()
  } catch (e) {
    console.error(e)
  }
}
